module.exports = __webpack_public_path__ + "static/4-large-0e669ed7ad21af3b981cf1828dc766c8.jpg";